<template>
  <vx-card class="list-view-item overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <div class="vx-row item-details no-gutter">
        <!-- IMG COL -->
        <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer" @click="navigateLotView">
          <img :src="item.productPictureUrl" :alt="item.name" class="grid-view-img p-4">
        </div>

        <!-- ITEM NAME & DESC COL -->
        <div class="vx-col sm:w-1/2">
          <div class="p-4 pt-6">
            <slot name="item-meta">
              <p class="item-description font-semibold truncate text-sm">{{ remainingItemInfo(item) }}</p>
              <h6 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigateLotView">{{ item.name }}</h6>
              <p class="item-description text-sm">{{ getTypeText(item) }}</p>
              <p class="item-description text-sm">{{ getDuoDate(item) }}</p>
              <p class="item-description font-semibold truncate text-sm">{{ item.createCompanyName }}</p>
              <p class="item-description truncate text-sm">Pedido No.: {{ item.orderId ? item.orderId : 'N/A' }}</p>
              <p class="item-description truncate text-sm">NF No.: {{ item.nfId ? item.nfId : 'N/A' }}</p>
            </slot>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
          <div class="p-4 flex flex-col w-full">
            <div class="my-6">
              <h5 class="font-bold text-center">${{ item.price }}</h5>
              <span class="text-grey flex items-start justify-center mt-1" v-if="item.free_shipping">
                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4" />
                <span class="text-sm ml-2">Free Shipping</span>
              </span>
            </div>
            <!-- SLOT: ACTION BUTTONS -->
            <slot name="action-buttons" />
          </div>
        </div>

      </div>
    </template>
  </vx-card>
</template>

<script>
export default{
  props: {
    item: { type: Object, required: true },
    groupedMovements: { type: Array, required: false }
  },
  methods: {
    remainingItemInfo (item) { return `${this.stockQuantity(item)} ${item.unit} restante do lote` },
    stockQuantity (item) {
      const mov = this.groupedMovements.find(e => e.ProductId === item.id)
      if (item.LotsProduct.LotId) return item.LotsProduct.quantity.toFixed(2)
      return (mov) ? mov.quantity.toFixed(2) : 0
    },
    getTypeText (data) { return data.typeText ? data.typeText : 'N/A' },
    getCategory (data) {
      if (data.packing) return 'Embalagem'
      if (data.residue) return 'Resíduo'
      return data.toBeProcessed ? 'Processado' : 'Natural'
    },
    getDuoDate (data) {
      console.log(data)
      if (!data.validDays) return 'Sem validade definida'
      const duoDate = new Date(new Date(data.LotsProduct.createdAt).getTime() + ((data.validDays) * 24 * 60 * 60 * 1000))
      return `Válido até ${duoDate.toLocaleDateString()}`
    },
    navigateLotView () {
      if (this.item.LotsProduct.LotId) {
        this.$router.push({ name: 'app-lot-view', params: { userId: this.item.LotsProduct.LotId } })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-item {
  .item-name, .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

    .grid-view-img{
      opacity: 0.9;
    }
  }
}
</style>
